import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { businessesReducer } from './reducers/businessesReducer'
import { movementsReducer } from './reducers/movementsReducer'
import { balancesReducer } from './reducers/balancesReducer'
import { billsReducer } from './reducers/billsReducer'
import { billExternalsReducer } from './reducers/billExternalsReducer'
import { logsReducer } from './reducers/logsReducer'

const intialState = {}
const appReducer = combineReducers({
    businesses: businessesReducer,
    movements: movementsReducer,
    balances: balancesReducer,
    bills: billsReducer,
    billExternals: billExternalsReducer,
    logs: logsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, intialState, composeEnhancer(applyMiddleware(thunk)))

export default store